import { render, staticRenderFns } from "./update-registration-page.vue?vue&type=template&id=10825cd2&scoped=true&"
import script from "./update-registration-page.vue?vue&type=script&lang=js&"
export * from "./update-registration-page.vue?vue&type=script&lang=js&"
import style0 from "./update-registration-page.vue?vue&type=style&index=0&id=10825cd2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10825cd2",
  null
  
)

export default component.exports